"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _header = _interopRequireDefault(require("../../control-components/header"));

var _customCss = _interopRequireDefault(require("../custom-css/customCss"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CustomCssWrapper = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CustomCssWrapper, _Component);

  var _super = _createSuper(CustomCssWrapper);

  function CustomCssWrapper() {
    (0, _classCallCheck2.default)(this, CustomCssWrapper);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(CustomCssWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          content = _this$props.content,
          currentUrl = _this$props.currentUrl;
      return (0, _preact.h)("div", null, (0, _preact.h)(_header.default, {
        title: "Custom CSS",
        disableCancelButton: true,
        disableSaveButton: true,
        customButtons: [{
          title: 'Cancel',
          variant: 'secondary',
          url: currentUrl
        }, {
          title: 'Save changes',
          variant: 'success',
          action: 'js-submit-custom-css'
        }]
      }), (0, _preact.h)(_customCss.default, {
        content: content
      }));
    }
  }]);
  return CustomCssWrapper;
}(_preact.Component);

var _default = CustomCssWrapper;
exports.default = _default;